const $doc = $(document)

$doc.on('click', '.js-load-actions-btn', function(e) {
  e.preventDefault()
  const $this = $(this)
  const href = $this.attr('href')

  $.ajax({
    url: href,
    success: function (data) {
      const $data = $(data)
      const $dataProducts = $data.find('.js-items-load-more')
      const $dataBtn = $data.find('.js-load-actions-btn')
      const $products = $('.js-items-load-more')
      const $actions = $('.js-load-actions')
      let actionsHtml = ''

      if ($dataProducts.length && $products.length) {
        $products.append($dataProducts.html())
      }

      if ($dataBtn.length) {
        actionsHtml = $dataBtn
      }

      if ($actions.length) {
        $actions.html(actionsHtml)
      }
    }
  })
})
